<template>
    <div class="container">
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img class="img" :src="item">
            <div class="activityBox" v-if="activity.isShow && index == 0">
                <img class="activityImg" :src="activity.PCactiveImg">
            </div>
        </div>

        <div class="section-main">
            <div class="_tb">
                <el-tabs v-model="activeName" @tab-click="changeTab">
                    <el-tab-pane class="main-tab" v-for="(item, index) in stageList" :key="index" :label="item.stage" :name="index">
                        <div class="region">
                            <div class="m-title"><div class="tx">{{item.title}}</div> <div v-if="item.details.length > 0" class="btn" @click="showModalFn(item)"></div></div>
                            <div class="m-icon"></div>
                            <div class="m-txt">
                                <div class="m-left">
                                    <div class="l-title">学习目标</div>
                                    <div class="item" v-for="(v, i) in item.phaseTargetList" :key="i" >{{v}}</div>
                                </div>
                                <div class="m-right">
                                    <div class="l-title">关键技术点</div>
                                    <div class="item" v-for="(v, i) in item.skillsList" :key="i" >{{v}}</div>
                                </div>
                            </div>
                        </div>
                        
                    </el-tab-pane>
                </el-tabs>
                <button class="stage-more" @click="JumpFn">
                    <img :src="btnList[1]">
                </button>
                <!-- <div class="tips-tab">
                    * 具体课程内容以实际课程安排和进度为准
                </div> -->
            </div>
            <div class="modal" v-if="showModal">
                <img @click="close" class="close" src="https://s21.lgstatic.com/growth/activity/20210412/1618215171460.png">
                <div v-for="(item, index) in showData.details" :key="index">
                    <div class="modal-title">
                        {{item.t}}
                    </div>
                    <div class="modal-desc" v-for="(i, is) in item.desc" :key="is">
                        {{i}}
                    </div>
                </div>
            </div>
            
        </div>

        <div class="section" v-for="(item, index) in imgList1" :key="index">
            <img class="img" :src="item">
        </div>

        <div class="section-sw">
            <div class="swiper-container current-wrap">
                <div class="swiper-wrapper">
                    <div v-for="item in swiperList" :key="item" class="swiper-slide">
                        <img :src="item" >
                    </div>
                </div>
                <!-- <div class="swiper-pagination current-pagination" /> -->
            </div>
        </div>

        <button class="btn-more" @click="JumpFn">
            <img :src="btnList[0]">
        </button>
        <div class="section">
            <img class="img" :src="btnList[2]">
        </div>
        <button class="btn-more" @click="JumpFn">
            <img :src="btnList[3]">
        </button>

        <div class="section" v-for="(item, index) in imgList2" :key="index">
            <img class="img" :src="item">
        </div>

        
        <button class="footer" @click="JumpFn">
            <img class="img" :src="btnList[4]">
            <div class="iconBox" v-if="activity.isShow">
                <img class="icon" :src="activity.PCicon">
            </div>
        </button>

    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import activity from '../../../common/activity';
import List from './list.js'
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
export default {
    data() {
        return {
            activity,
            List,
            showModal:false,
            imgList:[],
            imgList1:[],
            imgList2:[],
            btnList:[],
            swiperList:[],
            showData:{},
        }
    },
    mounted () {
        setTimeout(()=>{
            this.eduPlatTrack('WebView', { page_id: '1r93'});
        },500)
        let dataList = this.List.data.pc;
        this.imgList = dataList.imgList
        this.imgList1 = dataList.imgList1
        this.imgList2 = dataList.imgList2
        this.swiperList = dataList.swiperList
        this.btnList = dataList.btnList
        
        this.stageList = this.List.data.stageList

        this.renderSwiper()
    },
    methods: {
        JumpFn() {
            this.eduPlatTrack('WebButtonClick', {
                'page_id': '1r93',
                'button_name': '限时领取'
            });
            handleJumpUrl(`1a06e29ba67b45b3aa2166a14cd7e530`);
        },
        close() {
            this.showModal = false;
        },
        changeTab(val) {
            this.showModal = false
        },
        showModalFn(item) {
            this.showModal = true
            this.showData = item
        },
        renderSwiper() {
            setTimeout(() => {
                let modify = 0;
                let translate = 0;
                let scale = 0;
                const swiper = new Swiper('.current-wrap', {
                    autoplay: 3200,
                    loop: true,
                    slidesPerView: 'auto',
                    loopedSlides: 4,
                    // pagination: '.current-pagination',
                    paginationClickable: true,
                    watchSlidesProgress: true,
                    centeredSlides: true,
                    onSetTransition: (swiper, transition) => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slide = swiper.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                });
                swiper.on('progress', () => {
                    for (let i = 0; i < swiper.slides.length; i++) {
                        let slide = swiper.slides.eq(i);
                        let slideProgress = swiper.slides[i].progress;
                        modify = 1;
                        if (Math.abs(slideProgress) > 1) {
                            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                        }
                        translate = slideProgress * modify * 350 + 'PX';
                        scale = 1 - Math.abs(slideProgress) / 5;
                        let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                        slide.css('zIndex', zIndex);
                    }
                });
            }, 500);
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    background: #F8F8F8;
    padding-bottom: 150PX;
    .section {
        position: relative;
        width: 100%;
        min-width: 1200PX;
        .img {
            width: 100%;
            display: block;
        }
        .activityBox {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%);
            width: 950PX;
            height: 150PX;
        }
        .activityImg {
            display: block;
            float: right;
            width: 104PX;
            height: 133PX;
        }
    }

    .section-main {
        position: relative;
        width: 100%;
        min-width: 1200PX;
        padding: 1PX 0 80PX;
        background: #F8F8F8;
        ._tb {
            position: relative;
            margin: 15PX auto 0;
            width: 1000PX;
            background-color: #fff;
            box-shadow: 0PX 2PX 20PX 0PX rgba(83, 84, 124, 0.08);
            box-sizing: border-box;
            padding: 0PX 0PX 50PX;
            border-radius: 22px;
            /deep/ .el-tabs {
                width: 100%;
                
                .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll, .el-tabs__nav {
                    height: 76PX;
                    background: linear-gradient(322deg, #2F41F7 0%, #161354 100%);
                    border-top-left-radius: 22PX;
                    border-top-right-radius: 22PX;
                }
                .el-tabs__item {
                    line-height: 76PX;
                    text-align: center;
                    width: 150PX;
                    height: 76PX;
                    padding: 0;
                    font-size: 22PX;
                    font-family: SourceHanSansSC-Bold, SourceHanSansSC;
                    font-weight: 400;
                    color: #fff;
                    margin: 0 8PX;
                    opacity: .6;
                }
                .el-tabs__nav-next, .el-tabs__nav-prev {
                    font-size: 24PX;
                    margin-top: 16PX;
                    color: #fff;
                }
                .el-tabs__nav-wrap.is-scrollable {
                    padding: 0 36PX;
                }
                .el-tabs__nav-wrap::after{
                    background-color: transparent;
                }
                .el-tabs__active-bar {
                    background-color: transparent; 
                }
                .el-tabs__item.is-active {
                    font-weight: bold;
                    color: #fff;
                    opacity: 1;
                }
            }
            .region {
                width: 100%;
                box-sizing: border-box;
                padding: 20PX 40PX;
                .m-title {
                    width: 100%;
                    height: 30PX;
                    position: relative;
                    font-size: 24PX;
                    color: #303032;
                    text-align: center;
                    font-family: Helvetica;
                    font-weight: normal;
                    .tx {
                        position: absolute;
                        top: 0PX;
                        left: 50%;
                        transform: translate(-50%);
                    }
                    .btn {
                        float: right;
                        width: 90PX;
                        height: 30PX;
                        background: url('https://s21.lgstatic.com/growth/activity/20210325/1616656811847.png') no-repeat;
                        background-size: 100% 100%;
                        margin-right: 40PX;
                    }
                }
                .m-icon {
                    margin: 8PX auto;
                    width: 688PX;
                    height: 2PX;
                    background: url('https://s21.lgstatic.com/growth/activity/20210402/1617345169076.png') no-repeat center;
                    background-size: 100% 100%;
                }
                .m-txt {
                    width: 100%;
                    // display: flex;
                    margin-top: 30PX;
                    .m-left {
                        // flex: 1;
                        box-sizing: border-box;
                        padding: 10PX 30PX;
                    }
                    .m-right {
                        // width: 360PX;
                        box-sizing: border-box;
                        padding: 10PX 30PX;
                    }
                    .l-title {
                        font-size: 16PX;
                        font-family: Helvetica;
                        color: #6469A7;
                        position: relative;
                        background: linear-gradient(192deg, rgba(99, 137, 255, .1) 0%, rgba(108, 101, 255, .1) 100%);
                        border-radius: 23px;
                        padding: 4PX 20PX;
                        display: inline-block;
                    }
                    .item {
                        position: relative;
                        font-size: 14PX;
                        font-family: Helvetica;
                        color: #49494B;
                        padding-left: 15PX;
                        margin: 14PX 0;
                        &::after {
                            position: absolute;
                            content: '';
                            left: 0PX;
                            top: 8PX;
                            width: 4PX;
                            height: 4PX;
                            border-radius: 50%;
                            background: #959DFF;
                        }
                    }
                }
            }
            .tips-tab {
                font-size: 14PX;
                color: #666;
                position: absolute;
                bottom: 80PX;
                right: 40PX;
            }
            .stage-more {
                position: absolute;
                bottom: -54PX;
                left: 50%;
                transform: translate(-50%);
                width: 448PX;
                background-color:transparent;
                border: none;
                z-index: 9;
                img {
                    width: 100%;
                    display: block;
                }
            }

        }
        .modal {
            position: absolute;
            top: 180PX;
            left: 50%;
            transform: translate(-50%);
            width: 800PX;
            border-radius: 16PX;
            background-color: #fefefe;
            z-index: 999;
            border: 2PX solid #6469A7;
            box-sizing: border-box;
            padding: 20PX 50PX 40PX;
            .close {
                position: absolute;
                right: 14PX;
                top: 14PX;
                width: 40PX;
                height: 40PX;
            }
            .modal-title {
                font-size: 20PX;
                padding:35PX 0 10PX;
                color: #6469A7;
            }
            .modal-desc {
                font-size: 14PX;
                color: #6469A7;
                padding-left: 18PX;
            }
        }
        
    }

    .section-sw {
        position: relative;
        width: 100%;
        margin-top: 40PX;
        min-width: 1200PX;
        background: #F8F8F8;
        padding: 1PX 0 80PX;
        /deep/ .current-wrap {
            width: 1200PX;
            // height: 430PX;
            .swiper-slide {
                width: 600PX;
                opacity: 0;
                img {
                    display: block;
                    width: 600PX;
                    margin: 0 auto;
                }
                &.swiper-slide-active {
                    opacity: 1;
                }
                &.swiper-slide-next, &.swiper-slide-prev {
                    opacity: .5;
                }
            }
        }
    }

    .btn-more {
        display: block;
        margin: 0 auto;
        width: 448PX;
        background-color:transparent;
        border: none;
        img {
            width: 100%;
            display: block;
        }
    }

    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1PX;
        left: 50%;
        transform: translate(-50%);
        z-index: 999;
        width: 100%;
        box-shadow: 0PX -12PX 12PX 0PX rgba(156, 157, 185, 0.22);
        .img {
            width: 100%;
            display: block;
        }
        .iconBox {
            position: absolute;
            top: -30PX;
            left: 50%;
            transform: translate(-50%);
            z-index: 9999;
            width: 940PX;
            .icon {
                float: right;
                width: 134PX;
            }
        }
    }
} 
</style>